import { Placeholder } from "@telegram-apps/telegram-ui";
import { isEmpty } from "lodash-es";
import { useTranslation } from "react-i18next";
import LottieSticker from "~/components/LottieSticker";

const InsufficientBalance: React.FC<{ errMsg?: string }> = ({ errMsg }) => {
    const { t } = useTranslation();
    return (
        <div>
            <Placeholder
                className="pb-10 pt-5 gap-1"
                header={
                    <span className="text-text_1 text-h4">
                        {t("insufficient_balance")}
                    </span>
                }
                description={
                    <p className="text-text_2 text-body1">
                        {isEmpty(errMsg)
                            ? t("insufficient_wallet_balance_tip")
                            : errMsg}
                    </p>
                }
            >
                <LottieSticker lottieName="sad" className="w-[80px] h-[80px]" />
            </Placeholder>
        </div>
    );
};

export default InsufficientBalance;
